module.exports = __webpack_public_path__ + "media/video-intro.e6d2512b.mp4";